"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarthEmbassy = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var Options_1 = require("../Options");
var EarthEmbassy = (function (_super) {
    __extends(EarthEmbassy, _super);
    function EarthEmbassy() {
        return _super.call(this, {
            name: CardName_1.CardName.EARTH_EMBASSY,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.EARTH],
            cost: 16,
            metadata: {
                cardNumber: 'M77',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('After being played, when you perform an action, your Moon tags count as Earth tags, but not vice versa.', function (eb) {
                        eb.empty().startEffect.moon().equals().earth(1, { played: Options_1.played });
                    });
                }),
            },
        }) || this;
    }
    ;
    EarthEmbassy.prototype.play = function () {
        return undefined;
    };
    return EarthEmbassy;
}(Card_1.Card));
exports.EarthEmbassy = EarthEmbassy;
